import {spawnErrorToast} from '@hm/fundamental'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {QueryKeyName, deleteComment} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'
import {PomComment} from '../../types'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const useDeleteComment = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const plantId = usePlantUpmId()
  const client = useQueryClient()

  return useMutation({
    mutationFn: (comment: PomComment) => deleteComment({plantId, comment}),
    onSuccess: () => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetComments]})
    },
    onError: () => {
      spawnErrorToast(t('comments.deleted.error'))
    }
  })
}
